// extracted by mini-css-extract-plugin
export default {"container":"CarsPage_container__Oo3P1","containerOne":"CarsPage_containerOne__jp45f","header":"CarsPage_header__CFmdO","cards":"CarsPage_cards__lMUhA"};